export const addLogo = () => {
    const jobTiles = document.querySelectorAll(".attrax-vacancy-tile");

    if (!jobTiles) {
        return;
    }

    jobTiles.forEach((jobTile) => {
        let logoWrapper = document.createElement("div");
        logoWrapper.classList.add("attrax-vacancy-tile__logo-wrapper");
        jobTile.prepend(logoWrapper);
    });
};

export const brandClassAssignment = () => {
    const brandtiles = document.querySelectorAll(
        ".attrax-vacancy-tile__option-brand"
    );

    if (!brandtiles) {
        return;
    }

    brandtiles.forEach((brandtile) => {
        const brandclass = [...brandtile.classList].find((el) =>
            el.includes("attrax-vacancy-tile__option-brand--")
        );

        if (!brandclass) {
            return;
        }

        brandtile.closest(".attrax-vacancy-tile")?.classList.add(brandclass);
    });
};

export const setActive = () => {
    const jobtiles = document.querySelectorAll(".attrax-vacancy-tile");

    if (!jobtiles) {
        return;
    }

    jobtiles.forEach((jobtile) => {
        jobtile.classList.add("attrax-vacancy-tile--active");
    });
};
